import Marquee from 'react-fast-marquee';
import { usePrices } from '@/hooks/usePrices';

export default function ShillTicker() {
    const { prices, isLoading } = usePrices();

    if (isLoading || prices.length === 0) {
        return (
            <div className="h-12 bg-void border-b border-neon-green/30 flex items-center justify-center">
                <span className="text-neon-green/50 font-mono text-sm animate-pulse">
                    LOADING ALPHA...
                </span>
            </div>
        );
    }

    return (
        <div className="h-12 bg-void/90 backdrop-blur-sm border-b border-neon-green/30 flex items-center overflow-hidden">
            <Marquee
                speed={50}
                gradient={false}
                className="overflow-hidden"
            >
                {prices.map((coin, index) => (
                    <div
                        key={coin.symbol}
                        className="flex items-center gap-2 mx-8 font-mono"
                    >
                        <span className="text-zinc-500 text-sm">{coin.symbol}</span>
                        <span className="text-white font-bold">
                            ${coin.price.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: coin.price < 1 ? 6 : 2
                            })}
                        </span>
                        <span
                            className={`text-sm font-medium ${coin.change24h >= 0 ? 'text-neon-green' : 'text-red-500'
                                }`}
                        >
                            {coin.change24h >= 0 ? '▲' : '▼'}
                            {Math.abs(coin.change24h).toFixed(2)}%
                        </span>

                        {/* Separator */}
                        {index < prices.length - 1 && (
                            <span className="text-neon-green/30 ml-6">◆</span>
                        )}
                    </div>
                ))}
            </Marquee>
        </div>
    );
}
